import { IRootScopeService, ITimeoutService, IScope } from "angular";

import { IHandleIndicatorOptions, IUIError, IIndicatorErrorOptions, UIErrorHandlingService } from "@gtmhub/error-handling";

export interface IIndicatorScope extends IScope {
  longLastingRequest: boolean;
  timingOut: boolean;
  indicatorId: string;
  error: IUIError;
  indicatorOptions: IIndicatorErrorOptions;
}

export class IndicatorCtrl {
  public static $inject = ["$rootScope", "$scope", "$timeout", "UIErrorHandlingService"];

  constructor(
    private $rootScope: IRootScopeService,
    private $scope: IIndicatorScope,
    private $timeout: ITimeoutService,
    private uiErrorHandlingService: UIErrorHandlingService
  ) {
    this.$scope.indicatorId = "";
    this.$rootScope.$on("errorReceived", this.handleError);
    this.init();
  }

  private init = () => {
    this.$timeout(() => {
      this.$scope.longLastingRequest = true;
    }, 5000);

    this.$timeout(() => {
      this.$scope.timingOut = true;
    }, 80000);
  };

  private handleError = (ev, options: IHandleIndicatorOptions) => {
    // when displaying error with modal
    // we still broadcast event without passing options.indicatorOptions parameter
    // if so stop execution
    if (!options || !options.indicatorOptions) {
      return;
    }

    let indicatorBase: string;
    const controllerAs = "$ctrl.";
    const root = "$root.";

    if (options.indicatorOptions.indicator.split("[").length > 1) {
      indicatorBase = "indicators";
    } else {
      indicatorBase = "indicators.";
    }

    if (this.$scope.indicatorId.includes(controllerAs)) {
      indicatorBase = controllerAs + indicatorBase;
    }

    if (this.$scope.indicatorId.includes(root)) {
      indicatorBase = root + indicatorBase;
    }

    if (options.indicatorOptions.indicator && this.$scope.indicatorId === indicatorBase + options.indicatorOptions.indicator) {
      // if error is not passed --> configure generic error message
      if (!options.error) {
        options.error = {
          body: null,
          type: "unexpected",
          title: "unexpected_error_title",
          message: "unexpected_error_message",
          showIntercomLink: true,
        };
      }

      this.showError(options);
      this.uiErrorHandlingService.trackError("indicator");
    }
  };

  private showError = (options: IHandleIndicatorOptions) => {
    this.$scope.error = options.error;
    this.$scope.indicatorOptions = options.indicatorOptions;
  };
}
